import React, { useState, useEffect } from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Button,
  Stack,
  Menu,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { NavLink, useNavigate } from "react-router-dom";

const theme = createTheme({
  palette: {
    primary: { main: "#fff" },
    secondary: { main: "#ffffff" },
  },
});

const navItems = [
  { label: "Home", path: "/" },
  { label: "Pledge", path: "/pledge" },
  { label: "Team", path: "/team" },
  { label: "7 Missions", path: "/7missions" },
  { label: "Rewards", path: "/rewards" },
];

const programmeItems = [
  { label: "IAP Schools & Colleges - Universities", path: "/Schools-Colleges-Universities" },
  { label: "IAP Organisations & Corporates", path: "/Organisations-Corporates" },
  { label: "IAP Events", path: "/Events" },
  { label: "IAP Cities", path: "/Cities" },
  { label: "IAP Networks & IAP International Directors", path: "/Networks-International-Directors" },
  { label: "IAP Gifts", path: "/Gifts" },
  { label: "IAP Institute", path: "/Institute" },
  { label: "IAP Influencers", path: "/Influencers" },
  { label: "IAP Welfare Fund", path: "/Welfare-Fund" },
  { label: "IAP Cafee", path: "/Cafee" },
  { label: "IAP Voices", path: "/Voices" },
  { label: "IAP Arts & Publications", path: "/Arts-and-Publications" },
];

const helpItems = [
   {label: "Brochures", path: "/download" },
  { label: "Contact", path: "/contact" },
  
];

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [programmeOpen, setProgrammeOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [helpAnchorEl, setHelpAnchorEl] = useState(null);

  const openProgramme = Boolean(anchorEl);
  const openHelp = Boolean(helpAnchorEl);

  const navigate = useNavigate();
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  const handleMobileNavigate = (path) => {
    setDrawerOpen(false);
    navigate(path);
  };

  const handleDesktopMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDesktopMenuClose = (path) => {
    setAnchorEl(null);
    if (path) navigate(path);
  };

  const handleHelpMenuOpen = (event) => {
    setHelpAnchorEl(event.currentTarget);
  };

  const handleHelpMenuClose = (path) => {
    setHelpAnchorEl(null);
    if (path) navigate(path);
  };

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <AppBar
        position="sticky"
        color="primary"
        elevation={0}
        top={0}
        sx={{
          borderBottom: "1px solid #f5f5f5",
          zIndex: (theme) => theme.zIndex.drawer,
        }}
        className={`HeaderSection ${isScrolled ? "scrolled" : ""}`}
      >
        <Toolbar sx={{ justifyContent: "space-between", flexWrap: "wrap" }}>
          {isMobile ? (
            <>
              <IconButton onClick={toggleDrawer} color="inherit">
                <MenuIcon />
              </IconButton>

              <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={toggleDrawer}
                ModalProps={{
                  keepMounted: true,
                  sx: {
                    zIndex: (theme) => theme.zIndex.drawer + 900,
                  },
                }}
                PaperProps={{
                  sx: {
                    width: 280,
                    bgcolor: "#fff",
                    color: "#000",
                    pt: 2,
                  },
                }}
              >
                <List>
                  {navItems.map((item) => (
                    <ListItem
                      key={item.label}
                      button
                      onClick={() => handleMobileNavigate(item.path)}
                    >
                      <ListItemText primary={item.label} />
                    </ListItem>
                  ))}

                  {/* IAPM PROGRAMMES */}
                  <ListItem button onClick={() => setProgrammeOpen(!programmeOpen)}>
                    <ListItemText primary="IAPM PROGRAMMES" />
                    {programmeOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>

                  <Collapse in={programmeOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {programmeItems.map((item) => (
                        <ListItem
                          key={item.label}
                          button
                          sx={{ pl: 4 }}
                          onClick={() => handleMobileNavigate(item.path)}
                        >
                          <ListItemText primary={item.label} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>

                  {/* HELP & RESOURCES */}
                  <ListItem button onClick={() => setHelpOpen(!helpOpen)}>
                    <ListItemText primary="Help & Resources" />
                    {helpOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>

                  <Collapse in={helpOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {helpItems.map((item) => (
                        <ListItem
                          key={item.label}
                          button
                          sx={{ pl: 4,  width:"100px", height:"2rem" }}
                          onClick={() => handleMobileNavigate(item.path)}
                        >
                          <ListItemText primary={item.label} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </List>
              </Drawer>
            </>
          ) : (
            <Stack direction="row" spacing={2} className="ml-auto mainHeader">
              {navItems.map((item) => (
                <Button
                  key={item.label}
                  component={NavLink}
                  to={item.path}
                  exact="true"
                  color="inherit"
                  sx={{
                    fontWeight: 500,
                    "&.active": {
                      fontWeight: "bold",
                      color: "#000",
                      fontFamily: "DIN Pro Medium !important",
                    },
                  }}
                >
                  {item.label}
                </Button>
              ))}

              {/* IAPM PROGRAMMES */}
              <Box
                onMouseEnter={handleDesktopMenuOpen}
                onMouseLeave={() => handleDesktopMenuClose()}
                sx={{ cursor: "pointer" }}
              >
                <Button
                  color="inherit"
                  className="iapmMainnavBtn"
                  onClick={handleDesktopMenuOpen}
                  sx={{
                    fontWeight: 500,
                    borderBottom: "2px solid transparent",
                    borderRadius: 0,
                    transition: "border-color 0.2s ease-in-out",
                    "&:hover": {
                      borderBottom: "2px solid #393939",
                      borderRadius: 0,
                    },
                  }}
                >
                  IAPM PROGRAMMES
                </Button>

                <Menu
                  className="iapmPopup"
                  anchorEl={anchorEl}
                  open={openProgramme}
                  onClose={() => handleDesktopMenuClose()}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                  MenuListProps={{
                    onMouseLeave: () => handleDesktopMenuClose(),
                  }}
                >
                  {programmeItems.map((item) => (
                    <MenuItem
                      key={item.label}
                      onClick={() => handleDesktopMenuClose(item.path)}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </Menu>
              </Box>

              {/* HELP & RESOURCES (Replaced Contact) */}
              <Box
                onMouseEnter={handleHelpMenuOpen}
                onMouseLeave={() => handleHelpMenuClose()}
                sx={{ cursor: "pointer" }}
              >
                <Button
                  color="inherit"
                  sx={{
                    fontWeight: 500,
                    borderBottom: "2px solid transparent",
                    borderRadius: 0,
                    transition: "border-color 0.2s ease-in-out",
                    "&:hover": {
                      borderBottom: "2px solid #393939",
                      borderRadius: 0,
                    },
                  }}
                >
                  Contact & Brochures
                </Button>

                <Menu
                  anchorEl={helpAnchorEl}
                  open={openHelp}
                  onClose={() => handleHelpMenuClose()}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                  MenuListProps={{
                    onMouseLeave: () => handleHelpMenuClose(),
                  }}
                   PaperProps={{
    sx: {
      width: "180px",
      textAlign:"center", // 🔥 increase width here
    },
  }}
                >
                  {helpItems.map((item) => (
                    <MenuItem
                      key={item.label}
                      onClick={() => handleHelpMenuClose(item.path)}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            </Stack>
          )}
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}

export default Header;